import React from "react";

interface FloatingActionBarProps {
    dirtyCount: number;
    cycleYear: number;
    handleDiscardChanges: () => void;
    handleOpenSave: () => void;
}

export const FloatingActionBar: React.FC<FloatingActionBarProps> = ({
    dirtyCount,
    cycleYear,
    handleDiscardChanges,
    handleOpenSave,
}) => {
    if (dirtyCount === 0) return null;

    return (
        <div style={{ position: "fixed", left: 0, right: 0, bottom: 0, display: "flex", justifyContent: "center", padding: "16px", zIndex: 40, pointerEvents: "none" }}>
            <div style={{ pointerEvents: "auto", background: "#0f172a", color: "#fff", borderRadius: "14px", padding: "12px 16px", display: "flex", alignItems: "center", gap: "16px", boxShadow: "0 12px 32px rgba(0,0,0,.25)" }}>
                <span style={{ fontSize: "13.5px", fontWeight: 600, padding: "0 4px" }}>
                    {dirtyCount} alteração(ões) pendente(s) no ciclo {cycleYear}
                </span>
                <div style={{ width: "1px", height: "22px", background: "rgba(255,255,255,.15)" }}></div>
                <button
                    onClick={handleDiscardChanges}
                    style={{ background: "none", color: "rgba(255,255,255,.6)", border: "none", fontSize: "13px", cursor: "pointer" }}
                >
                    Descartar
                </button>
                <button
                    onClick={handleOpenSave}
                    style={{ background: "#0d9488", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 16px", fontSize: "13px", fontWeight: 600, cursor: "pointer" }}
                >
                    Salvar reajustes
                </button>
            </div>
        </div>
    );
};
